module.exports = __webpack_public_path__ + "img/crew_onboarding.4951c624.jpg";